<template>
    <cookieconsent 
        message="To provide the best possible service this website uses cookies. Visitors who continue browsing the site authorize the use of cookies."
        linkLabel="Read More"
        buttonLabel="Got it!"
        :href="this.linkCookiePolicy"
    ></cookieconsent>
</template>
<script>

import cookieconsent from 'vue-cookieconsent-component'

export default {
    name: "CookieBanner",
    data(){
        return {
            linkCookiePolicy: process.env.VUE_APP_URL_PRIVACY
        }
    },
    components:{
        cookieconsent
    }
}
</script>
<style lang="scss">
@import "../../node_modules/vue-cookieconsent-component/src/scss/cookie-consent";
@import "../../node_modules/vue-cookieconsent-component/src/scss/cookie-consent-bottom";
@import "../../node_modules/vue-cookieconsent-component/src/scss/_cookie-consent-transition"; 
</style>
